import React from 'react';
import targetIllustration from '../../assets/images/landing/target.svg';
import { FIT_SIGNALS } from './landingContent';

const FitCheck = ({ selected, onToggle }) => {
 const count = selected.length;
 const onKeyDown = (event, index) => {
 if (event.key === ' ' || event.key === 'Enter') {
 event.preventDefault();
 onToggle(index);
 }
 };

 return (
 <section className="lp-section" id="fit" aria-labelledby="fit-title">
 <div className="lp-wrap">
 <div className="lp-head lp-reveal">
 <div>
 <p className="lp-eyebrow">06 - Fit check</p>
 <h2 id="fit-title" className="lp-fit-title">
 You’re a fit if…
 <img src={targetIllustration} alt="" width="118" height="96" />
 </h2>
 </div>
 <p className="lp-lede">
 Pick the ones that sound familiar. We’ll bring them into your Strategy Review so we start where it matters.
 </p>
 </div>

 <fieldset className="lp-fit">
 <legend className="lp-reveal">
 <span className="lp-eyebrow">Select all that apply</span>
 <span className="lp-fit-hint"> · click a card to select it</span>
 </legend>
 <div className="lp-fit-grid">
 {FIT_SIGNALS.map((signal, index) => {
 const isOn = selected.includes(index);
 return (
 <div
 key={signal.chip}
 className={`lp-fit-card lp-reveal${isOn ? ' is-on' : ''}`}
 role="checkbox"
 aria-checked={isOn}
 tabIndex={0}
 onClick={() => onToggle(index)}
 onKeyDown={(event) => onKeyDown(event, index)}
 >
 <span className="lp-fit-pill" aria-hidden="true">
 <b>{isOn ? '✓' : '+'}</b>
 {isOn ? 'Selected' : 'Sounds familiar'}
 </span>
 <span className="lp-fit-num" aria-hidden="true">0{index + 1}</span>
 <span className="lp-fit-text">{signal.text}</span>
 </div>
 );
 })}
 </div>
 </fieldset>

 <div className="lp-fit-next">
 <div>
 <p className="lp-fit-status" aria-live="polite">
 {count === 0
 ? 'Not sure? Book anyway - we’ll cover all of it.'
 : `${count} selected - we’ll start with these.`}
 </p>
 <p className="lp-fit-note">
 {count === 0
 ? 'Anything you select is added to your booking request.'
 : `${selected.map((index) => FIT_SIGNALS[index].chip).join(' · ')} - added to your booking request.`}
 </p>
 </div>
 <a className="lp-btn lp-btn-primary" href="#contact">
 Book a Strategy Review <span aria-hidden="true">→</span>
 </a>
 </div>
 </div>
 </section>
 );
};

export default FitCheck;
